/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsRpc
 */
import * as References from './FeaturedCalloutsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsRpc#getAllPublished
 */
export const GET_ALL_PUBLISHED_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_FeaturedCalloutsRpc_getAllPublished';
export const GET_ALL_PUBLISHED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_PUBLISHED_QUERY_FIELD_NAME,
  args: ['productType', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllPublishedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.FeaturedCalloutsRpc#getRelevantPublishedCalloutIds
 */
export const GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_quality_rpc_FeaturedCalloutsRpc_getRelevantPublishedCalloutIds';
export const GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_RELEVANT_PUBLISHED_CALLOUT_IDS_QUERY_FIELD_NAME,
  args: ['productType'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getRelevantPublishedCalloutIdsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});